export const destinations = [
	{
		id: 1,
		name: 'UK',
		details:
			'The United Kingdom, made up of England, Scotland, Wales and Northern Ireland, is an island nation in northwestern Europe. England – birthplace of Shakespeare and The Beatles – is home to the capital, London, a globally influential centre of finance and culture. England is also site of Neolithic Stonehenge, Bath’s Roman spa and centuries-old universities at Oxford and Cambridge',
		image: '/assets/destinations/uk.jpg',
		bigImage: '/assets/destinations/ukBig.jpg',
		language: 'English',
		currency: 'pound',
	},
	{
		id: 2,
		name: 'USA',
		details:
			'The U.S. is a country of 50 states covering a vast swath of North America, with Alaska in the northwest and Hawaii extending the nation’s presence into the Pacific Ocean. Major Atlantic Coast cities are New York, a global finance and culture center, and capital Washington, DC. Midwestern metropolis Chicago is known for influential architecture and on the west coast, Los Angeles Hollywood is famed for filmmaking',
		image: '/assets/destinations/usa.jpg',
		bigImage: '/assets/destinations/usaBig.jpg',
		language: 'English',
		currency: 'Dollor',
	},
	{
		id: 3,
		name: 'Thailand',
		details:
			"Thailand is a Southeast Asian country. It's known for tropical beaches, opulent royal palaces, ancient ruins and ornate temples displaying figures of Buddha. In Bangkok, the capital, an ultramodern cityscape rises next to quiet canalside communities and the iconic temples of Wat Arun, Wat Pho and the Emerald Buddha Temple (Wat Phra Kaew). Nearby beach resorts include bustling Pattaya and fashionable Hua Hin",
		image: '/assets/destinations/thailand.jpg',
		bigImage: '/assets/destinations/thailandBig.jpg',
		language: 'Thai',
		currency: 'Thai baht',
	},
	{
		id: 4,
		name: 'Spain',
		details:
			'Spain, a country on Europe’s Iberian Peninsula, includes 17 autonomous regions with diverse geography and cultures. Capital city Madrid is home to the Royal Palace and Prado museum, housing works by European masters. Segovia has a medieval castle (the Alcázar) and an intact Roman aqueduct. Catalonia’s capital, Barcelona, is defined by Antoni Gaudí’s whimsical modernist landmarks like the Sagrada Família church',
		image: '/assets/destinations/spain.jpg',
		bigImage: '/assets/destinations/spainBig.jpg',
		language: 'Spanish',
		currency: 'Euro',
	},
	{
		id: 5,
		name: 'Pakistan',
		details:
			"Pakistan, officially the Islamic Republic of Pakistan, is a country in South Asia. It is the world's fifth-most populous country with a population exceeding 212.2 million. It has the world's second-largest Muslim population. It is the 33rd-largest country by area, spanning 881,913 square kilometres",
		image: '/assets/destinations/pakistan.jpg',
		bigImage: '/assets/destinations/pakistanBig.jpg',
		language: 'Urdu',
		currency: 'Rupee',
	},
	{
		id: 6,
		name: 'France',
		details:
			'France, in Western Europe, encompasses medieval cities, alpine villages and Mediterranean beaches. Paris, its capital, is famed for its fashion houses, classical art museums including the Louvre and monuments like the Eiffel Tower. The country is also renowned for its wines and sophisticated cuisine. Lascaux’s ancient cave drawings, Lyon’s Roman theater and the vast Palace of Versailles attest to its rich history',
		image: '/assets/destinations/france.jpg',
		bigImage: '/assets/destinations/franceBig.jpg',
		language: 'French',
		currency: 'Euro',
	},
	{
		id: 7,
		name: 'Switzerland',
		details:
			'Switzerland is a mountainous Central European country, home to numerous lakes, villages and the high peaks of the Alps. Its cities contain medieval quarters, with landmarks like capital Bern’s Zytglogge clock tower and Lucerne’s wooden chapel bridge. The country is also known for its ski resorts and hiking trails. Banking and finance are key industries, and Swiss watches and chocolate are world renowned',
		image: '/assets/destinations/switzerland.jpg',
		bigImage: '/assets/destinations/switzerlandBig.jpg',
		language: 'German, French, Italian, Romansh',
		currency: 'Swiss franc',
	},
	{
		id: 8,
		name: 'Turkey',
		details:
			'Turkey, country that occupies a unique geographic position, lying partly in Asia and partly in Europe. Throughout its history it has acted as both a barrier and a bridge between the two continents.',
		image: '/assets/destinations/turkey.jpg',
		bigImage: '/assets/destinations/turkeyBig.jpg',
		language: 'Turkish',
		currency: 'lira',
	},
];
